import Configs from "../../vendorConfigs/Configs";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import GameModel from "../../../core/src/model/GameModel";
import ConsoleUtil from "../../../core/src/utils/ConsoleUtil";


export default class SetRealityCheckLimits implements IRequestBuilder {
    get method() {
        return "POST";
    }
  
    get path() {
        return Configs.game.clientConfig.gameServerApi + "/setrealitychecklimits";
    }
  
    get requestData() {
        let data = {
            sid: GameModel.sessionID,
            // TODO: How and where? lossLimit: 1000,
            sessionLimitSeconds: GameModel.urlParams.rcinterval,
            sessionElapsedSeconds: GameModel.urlParams.rcelapsed
        };
  
        ConsoleUtil.log("[Requests] Set Reality Check Limits", data);
        return data;
    }
}